import { useSuspenseQuery } from '@tanstack/react-query';
import { request } from './axios';

interface GitInfo {
  git: {
    commit: {
      id: { abbrev: string };
    };
    tags: string;
  };
}

const backendVersionQueryFunction = () => request<GitInfo>({ url: '/actuator/info' });

export const useBackendVersionQuery = () => {
  const { data } = useSuspenseQuery<GitInfo>({
    queryKey: ['backendVersion'],
    queryFn: backendVersionQueryFunction,
  });
  return data;
};
